import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const LocationsPage = Loader(
  lazy(() => import('content/pages/Private/Locations')),
);

const locationsRouter: RouteObject[] = [
  {
    path: 'locations',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <LocationsPage />,
      },
    ],
  },
];

export default locationsRouter;
